import { useMutation } from "@tanstack/react-query";

import { siQueryKeyFactory } from "app/pages/sales-intelligence/query/queryKeyFactory";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";
import type { RequestAdminFeature } from "app/pages/sales-intelligence/types/requestAdminFeature";

export const useRequestAccessFromAdminMutation = () => {
    return useMutation<void, Error, RequestAdminFeature>({
        mutationKey: siQueryKeyFactory.accountAdminsRequestAccess(),
        mutationFn: (feature) => salesApiService.contactAdmin.requestAccessFromAdmin(feature),
    });
};
